import { createTheme } from "@mui/material/styles";
import { BIBlue, BILightGrey, BIRed } from "../assets/helpers";

const theme = createTheme({
    mixins: {
        toolbar: {
          minHeight: 50, // Mobile height
          "@media (min-width:600px)": {
            minHeight: 50, // Desktop height
          },
        },
      },
    palette: {
      primary: {
        main: BIBlue
      },
      secondary: {
        main: BIRed
      },
      greyColor: {
        main: BILightGrey
      }
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: "0.8rem",
            padding: "4px 8px",
            "@media (max-width:600px)": {
              fontSize: "0.6rem",
              padding: "3px 6px"
            }
          }
        }
      }
    },

    typography: {
      fontFamily: "'Roboto', sans-serif",
      h1: {
        fontSize: "3rem",
        "@media (max-width:1200px)": { fontSize: "2.5rem" },
        "@media (max-width:900px)": { fontSize: "2rem" },
        "@media (max-width:600px)": { fontSize: "1.5rem" }
      },
      h2: {
        fontSize: "2.5rem",
        "@media (max-width:1200px)": { fontSize: "2rem" },
        "@media (max-width:900px)": { fontSize: "1.75rem" },
        "@media (max-width:600px)": { fontSize: "1.25rem" }
      },
      h3: {
        fontSize: "2rem",
        "@media (max-width:1200px)": { fontSize: "1.75rem" },
        "@media (max-width:900px)": { fontSize: "1.5rem" },
        "@media (max-width:600px)": { fontSize: "1.25rem" }
      },
      h4: {
        fontSize: "1.5rem",
        "@media (max-width:1200px)": { fontSize: "1.25rem" },
        "@media (max-width:900px)": { fontSize: "1.125rem" },
        "@media (max-width:600px)": { fontSize: "1rem" }
      },
      h5: {
        fontSize: "1.25rem",
        "@media (max-width:1200px)": { fontSize: "1.125rem" },
        "@media (max-width:900px)": { fontSize: "1rem" },
        "@media (max-width:600px)": { fontSize: "0.875rem" }
      },
      h6: {
        fontSize: "1rem",
        "@media (max-width:1200px)": { fontSize: "0.9rem" },
        "@media (max-width:900px)": { fontSize: "0.85rem" },
        "@media (max-width:600px)": { fontSize: "0.8rem" }
      },
      h7: {
        // Custom Variant
        fontSize: "0.875rem",
        "@media (max-width:1200px)": { fontSize: "0.8rem" },
        "@media (max-width:900px)": { fontSize: "0.75rem" },
        "@media (max-width:600px)": { fontSize: "0.7rem" }
      },
      body1: {
        fontSize: "0.940rem",
        "@media (max-width:1200px)": { fontSize: "0.940rem" },
        "@media (max-width:900px)": { fontSize: "0.8rem" },
        "@media (max-width:600px)": { fontSize: "0.7rem" }
      },
      body2: {
        fontSize: "0.8rem",
        "@media (max-width:1200px)": { fontSize: "0.8rem" },
        "@media (max-width:900px)": { fontSize: "0.70rem" },
        "@media (max-width:600px)": { fontSize: "0.60rem" }
      }
    }
  });

export default theme;
